import { Data } from "../../types/Data";
import { State } from "../../types/State";

export function getLabelSurface({
  state,
  data,
  defaultLabel,
}: {
  state: State;
  data: Data;
  defaultLabel: string;
}) {
  if (!state["surface-min"]) return defaultLabel;
  return `À partir de ${state["surface-min"]}m²`;
}
